import { UsersIcon } from '@heroicons/react/24/outline';
import { Avatar } from '@main/complykit/components/avatar';
import { forwardRef } from 'react';

export type AvatarOption = {
  id: string;
  displayName: string;
  avatarUrl?: string;
  kind?: 'team';
};

export type AvatarOptionVariant = 'detailed' | 'short';

/* The engines still speak Chakra's two avatar sizes; they map onto the
 * ComplyKit ramp (24 and 32px) here, in one place. */
export type AvatarOptionSize = 'xs' | 'sm';

export type AvatarOptionProps = AvatarOption & {
  variant?: AvatarOptionVariant;
  size?: AvatarOptionSize;
};

const SIZE: Record<AvatarOptionSize, 'sm' | 'md'> = { xs: 'sm', sm: 'md' };

export const AvatarOptionIcon = forwardRef<
  HTMLSpanElement,
  Pick<AvatarOptionProps, 'displayName' | 'avatarUrl' | 'kind' | 'size'>
>(function AvatarOptionIcon({ displayName, avatarUrl, kind, size = 'sm' }, ref) {
  if (kind === 'team') {
    return (
      <Avatar ref={ref} name={displayName} icon={UsersIcon} shape="square" size={SIZE[size]} />
    );
  }
  return <Avatar ref={ref} name={displayName} src={avatarUrl} size={SIZE[size]} />;
});
